import React, { Fragment } from 'react';
import '../../_assets/css/file.css';
import './style.css';
import { Form } from "react-bootstrap";
import axios from 'axios';
import ReactDatatable from '@ashvin27/react-datatable';
import { Card, CardBody, Col, Button } from 'reactstrap';
import { baseURL } from '../../_helpers';
import { TOKEN } from '../../_helpers/exports';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
// import { Customers } from './customer_view';
import Input from 'react-phone-number-input/input'
import { Link } from 'react-router-dom';
import Alert from '../../shared/components/Alert';
// import CreateAddress from '../Address/createCustomerAddress';
import * as moment from 'moment';
import Modal from 'react-modal';
import { MDBCloseIcon } from "mdbreact"
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import { FormControl } from 'react-bootstrap'
import Select from 'react-select';
import RefreshIcon from 'mdi-react/RefreshCircleIcon';

class Agents extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props)
        this.getDataUpdate = this.getDataUpdate.bind(this);
        this.handleFromDateUpdate = this.handleFromDateUpdate.bind(this);
        this.handleToDateUpdate = this.handleToDateUpdate.bind(this);
        this.applyCallback = this.applyCallback.bind(this);
        this.onSubmitAllocation = this.onSubmitAllocation.bind(this);

        this.state = {
            showComponent: false,
            hideComponent: true,
            moreinfo: false,
        };
        this.state = {
            isLoading: false,
            isShowError: false,
            isOpen: false,
            statusMessage: '',
            showError: false,
        }
        let now = new Date();
        let start = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
        let end = moment(start).add(1, "days").subtract(1, "seconds");
        this.state = {
            start: start,
            end: end
        }

        this.columns = [
            {
                key: "name",
                TrOnlyClassName: 'tsc',
                text: "Name",
                className: "tsc",
                align: "left"
            },
            {
                key: "msisdn",
                TrOnlyClassName: 'tsc',
                text: "Phone#",
                className: "tsc",
                align: "left"
            },
            {
                key: "email",
                TrOnlyClassName: 'tsc',
                text: "Email",
                className: "tsc",
                align: "left"
            },

            {
                key: "mcash",
                TrOnlyClassName: 'tsc',
                text: "Cash Amount",
                className: "tsc",
                altrueign: "left"
            },
            {
                key: "fcash",
                TrOnlyClassName: 'tsc',
                text: "Float Amount",
                className: "tsc",
                altrueign: "left"
            },
            {
                key: "ccash",
                TrOnlyClassName: 'tsc',
                text: "Commission Amount",
                className: "tsc",
                altrueign: "left"
            },
            {
                key: "status",
                TrOnlyClassName: 'tsc',
                text: "Status",
                className: "tsc",
                align: "left",
                cell: record => {
                    return (
                        <Fragment className="center"  >
                            {record.status === "deactivated" ?
                                <div>
                                    <span class="badge-danger" style={{ borderRadius: "5px", padding: "2px" }}>
                                        Deactivated
                                </span>
                                </div>
                                : null}
                            {record.status === "active" ?
                                <span class="badge-success" style={{ borderRadius: "5px", padding: "2px" }}>
                                    Active
                                </span>
                                : null}
                        </Fragment >
                    );
                }
            },

            {
                key: "action",
                text: "Options",
                TrOnlyClassName: 'cell',
                className: "tsc",
                width: 250,
                sortable: false,
                cell: record => {
                    return (
                        <Fragment className="center"  >
                            <div className="row">
                                <div className="col-6">
                                    {record.status === "active" ?
                                        <div>

                                            <button className="btn btn-primary  btn-sm"
                                                title="View"
                                                style={
                                                    { marginRight: '10px' }}
                                                onClick={
                                                    () => { if (window.confirm('Are you sure you want to deactivate this agent?')) this.onDeactivate(record) }}
                                            >
                                                Deactivate
                                     </button>
                                        </div>
                                        :
                                        <div>
                                            <button className="btn btn-primary  btn-sm"
                                                title="View"
                                                style={
                                                    { marginRight: '10px' }}
                                                onClick={
                                                    () => { if (window.confirm('Are you sure you want to activate this agent?')) this.onApprove(record) }}
                                            >
                                                Activate
                                   </button>
                                        </div>
                                    }
                                </div>

                                <div className="col-6">
                                    <button className="btn btn-success  btn-sm"
                                        title="View"
                                        style={
                                            { marginRight: '10px' }}
                                        onClick={
                                            () => this.agentallocate(record)} >
                                        Allocate
                                   </button>
                                </div>
                            </div>
                        </Fragment >
                    );
                }
            }
        ]
        this.config = {
            key_column: "tsc",
            length_menu: [10, 20, 50],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 10,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                filter: "Search...",
                no_data_text: "No data was found",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            }

        }
    }






    onDeactivate(record) {
        // console.log("Delete Record", record);

        let formData = {
            "session_id": TOKEN,
            "agent_id": record.id
        }
        axios.post(baseURL + 'deactivate_agent', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.getData()
                    // this._onButtonClick();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })

    }

    agentallocate(record) {
        this.toggleModal()


        let formData = {
            "session_id": TOKEN
        }
        this.setState({
            isLoading2: true,
            agent_id: record.id
        })
        let url = baseURL + "get_clients"
        axios.all([
            axios.post(url, formData),
        ]).then(axios.spread((clientResponse) => {

            this.setState({
                Client: clientResponse.data.clients,
                isLoading2: false
            })
        })).catch(error => {
            console.log('bayoo', error.response)
        })
    }

    Client() {
        // alert(JSON.stringify(this.state.client))
        return (
            this.state.Client &&
            (this.state.Client.length > 0 || this.state.Client.length === 0) &&
            this.state.Client.map((countyItem, i) => ({
                label: countyItem.name,
                customer_verification: countyItem.customer_verification,
                value: countyItem.id,
            }))
        );
    }

    onSelectChangesBank = value => {
        this.setState(
            {
                // customer_verification: value.customer_verification.toString(),
                client_name: value.label.toString(),
                client_id: value.value.toString()
            });
    };

    onApprove(record) {
        // console.log("Delete Record", record);

        let formData = {
            "session_id": TOKEN,
            "agent_id": record.id
        }
        axios.post(baseURL + 'activate_agent', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false });
                    this.getData()
                    // this._onButtonClick();
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })

    }
    handleFromDateUpdate(date) {
        this.setState({
            startDate: date.date
        })
    }
    handleToDateUpdate(date) {
        this.setState({
            endDate: date.date
        })
    }

    onSubmitAllocation(e) {
        e.preventDefault();

        let formData = {
            "session_id": TOKEN,
            "client_id": this.state.client_id,
            "agent_id": this.state.agent_id
        }

        this.setState({ isLoading: true });
        axios.post(baseURL + 'get_agents', formData, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': TOKEN
            },
        }).then((response) => {
            console.log('bayoo', response.data)
            if (response.data.code === "0000") {
                this.setState({ statusMessage: response.data.message, showError: false, isShowError: true, isLoading: false });
                window.scrollTo(0, 0)
                window.setTimeout(() => {
                    this.setState({ isShowError: false, isOpen: false, customer_verification: false, message: "", customer_id: "" });
                }, 2000);
            } else {
                this.setState({ statusMessage: response.data.message, showError: true, isShowError: false, isLoading: false });

                window.setTimeout(() => {
                    this.setState({
                        isLoading: false,
                        isShowError: false,
                        statusMessage: "",
                        showError: false
                    });
                }, 2000);
            }
        }).catch((error) => {
            console.log('bayoo', error)
            this.setState({
                statusMessage: error.response === undefined ? "Check your Internet" : error.response.data.message, showError: true, isShowError: false, isLoading: false
            });
            window.setTimeout(() => {
                this.setState({
                    isLoading: false,
                    isShowError: false,
                    showError: false,
                    errorShow: false
                });
            }, 2000);
        })
    }

    getDataUpdate() {
        // let queryString = ("filter_value=&page_number=0&page_size=10&sort_order=false")
        this.getData()
    }
    componentDidMount() {
        this.getData();
    }
    getData = (queryString = "") => {
        let formData = {
            "session_id": TOKEN,

        }
        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };
        let url = baseURL + "get_agents"
        axios.all([
            axios.post(url, formData),
        ]).then(axios.spread((agentResponse) => {
            this.setState({
                agent: agentResponse.data.agents,
                isLoading: false
            }, function () {
                var data = [];

                this.setState({
                    total: agentResponse.data.agents.length
                })

                for (let i = 0; i < this.state.agent.length; i++) {
                    let mcash = { mcash: this.state.agent[i].account.cash.toString() };
                    let fcash = { fcash: this.state.agent[i].account.float.toString() };
                    let ccash = { ccash: this.state.agent[i].account.commission.toString() };

                    let fbankname;
                    let cbankacc;
                    let mproduct;
                    // let date = { dates: (moment.utc(this.state.agent[i].time).format('YYYY-MM-DD')) };
                    if (this.state.agent[i].bank.name === null) {
                        let fbankname = { bankname: "_" };
                        let cbankacc = { bankacc: "_" };

                    } else {
                        let fbankname = { bankname: this.state.agent[i].bank.name.toString() };
                        let cbankacc = { bankacc: this.state.agent[i].bank.account_no.toString() };

                    }
                    data.push(Object.assign(mcash, mproduct, fcash, ccash, fbankname, cbankacc, this.state.agent[i]));
                    this.setState({
                        data: data
                    })
                }
            })
        })).catch(error => {
            console.log('bayoo', error.response)

        })
    }
    getData2 = (start, end) => {

        let Sdate = moment(start).format('YYYY-MM-DD HH:mm:ss');
        let Edate = moment(end).format('YYYY-MM-DD HH:mm:ss');

        let formData = {
            "session_id": TOKEN,

        }
        this.setState({
            isLoading: true,
        })
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "Authorization": TOKEN
            }
        };
        let url = baseURL + "get_agents"
        axios.all([
            axios.post(url, formData),
        ]).then(axios.spread((agentResponse) => {
            this.setState({
                agent: agentResponse.data.agents,
                isLoading: false
            }, function () {
                var data = [];

                this.setState({
                    total: agentResponse.data.agents.length
                })

                for (let i = 0; i < this.state.agent.length; i++) {
                    let mcash = { mcash: this.state.agent[i].account.cash.toString() };
                    let fcash = { fcash: this.state.agent[i].account.float.toString() };
                    let ccash = { ccash: this.state.agent[i].account.commission.toString() };

                    let fbankname;
                    let cbankacc;
                    let mproduct;
                    // let date = { dates: (moment.utc(this.state.agent[i].time).format('YYYY-MM-DD')) };
                    if (this.state.agent[i].bank.name === null) {
                        let fbankname = { bankname: "_" };
                        let cbankacc = { bankacc: "_" };

                    } else {
                        let fbankname = { bankname: this.state.agent[i].bank.name.toString() };
                        let cbankacc = { bankacc: this.state.agent[i].bank.account_no.toString() };

                    }
                    data.push(Object.assign(mcash, mproduct, fcash, ccash, fbankname, cbankacc, this.state.agent[i]));
                    this.setState({
                        data: data
                    })
                }
            })
        })).catch(error => {
            console.log('bayoo', error.response)

        })
    }
    applyCallback(startDate, endDate) {

        this.getData2(startDate, endDate);

    }



    toggleModal = e => {
        this.setState({
            isOpen: true,
        });
    };

    closeModal = e => {
        this.setState({
            isOpen: false,
        });
    };

    render() {
        const { showComponent, agent_name, agent_msisdn, agent_email, agent_status, account_cash, account_commission, account_float, bank_acc, bankname } = this.state;
        const { hideComponent } = this.state;
        const { moreinfo } = this.state;


        let ranges = {
            "Today Only": [moment(this.state.start), moment(this.state.end)],
            "Yesterday Only": [
                moment(this.state.start).subtract(1, "days"),
                moment(this.state.end).subtract(1, "days")
            ],
            "3 Days": [moment(this.state.start).subtract(3, "days"), moment(this.state.end)],
            "5 Days": [moment(this.state.start).subtract(5, "days"), moment(this.state.end)],
            "1 Week": [moment(this.state.start).subtract(7, "days"), moment(this.state.end)],
            "2 Weeks": [moment(this.state.start).subtract(14, "days"), moment(this.state.end)],
            "1 Month": [moment(this.state.start).subtract(1, "months"), moment(this.state.end)],
            "1 Year": [moment(this.state.start).subtract(1, "years"), moment(this.state.end)]
        };
        let local = {
            "format": "DD-MM-YYYY HH:mm",
            "sundayFirst": false
        }
        // let maxDate = moment(start).add(24, "hour")
        return (
            <div>
                {!hideComponent && (
                    <>
                        <Col md={12} lg={12}>
                            <Card>

                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <h5><b>Agents</b></h5><br />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="col-md-4 ">
                                                {/* <DateTimeRangeContainer
                                                    ranges={ranges}
                                                    start={this.state.start}
                                                    end={this.state.end}
                                                    local={local}
                                                    // maxDate={maxDate}
                                                    applyCallback={this.applyCallback}>
                                                    <FormControl
                                                        id="formControlsTextB"
                                                        type="text"
                                                        label="Text"
                                                        placeholder="Filter by Date"
                                                    />
                                                </DateTimeRangeContainer> */}
                                                {/* <button className=" float-right btn btn-primary btn-sm" onClick={e => {
                                                        this.toggleModal(e);
                                                    }} >Filter by date</button> */}
                                                {/* <input id="input" type="text" readOnly /> */}
                                            </div>
                                        </div>
                                        <div className="col-md-6">

                                            <button className="float-right" title="refresh" style={{ background: "white", border: "0px" }}
                                                onClick={this.getDataUpdate}>
                                                <RefreshIcon />
                                            </button>
                                        </div>
                                    </div>
                                    <Modal
                                        isOpen={this.state.isOpen}
                                        onRequestClose={e => {
                                            this.closeModal(e);
                                        }}
                                        contentLabel="My dialog"
                                        className="mymodalclient"
                                        onAfterOpen={() => {
                                            document.body.style.overflow = 'hidden';
                                        }}
                                        onAfterClose={() => {
                                            document.body.removeAttribute('style');
                                        }}
                                        overlayClassName="myoverlay"
                                        closeTimeoutMS={500}
                                    >
                                        <MDBCloseIcon onClick={this.closeModal} />
                                        <h4><b>Client Allocation</b></h4><br />
                                        {this.state.showError ? <div >
                                            <Alert color="danger" className="alert--colored" icon>
                                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                                </p>
                                            </Alert>
                                        </div> : null}
                                        {this.state.isShowError ? (
                                            <div>
                                                <Alert color="success" className="alert--colored" icon>
                                                    <p><span className="bold-text">{this.state.statusMessage}</span>
                                                    </p>
                                                </Alert>
                                            </div>
                                        ) : null}
                                        <br></br>
                                        <form className="form" onSubmit={this.onSubmitAllocation}>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <Select
                                                        isClearable
                                                        id="input"
                                                        options={this.Client()}
                                                        // onInputChange={this.loadOptions}
                                                        placeholder="Select Client"
                                                        autosize={true}
                                                        onChange={this.onSelectChangesBank}
                                                        isLoading={this.state.isLoading2}
                                                        // noOptionsMessage={() => 'nothing found'}
                                                        // loadingMessage={() => 'searching...'}   //minor type-O here
                                                        menuPortalTarget={document.body}
                                                        name="namffe"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 offset-2">
                                                <br />
                                                <button
                                                    type="submit"
                                                    onClick={this.check2}
                                                    className="pull-right btn btn-primary btn-sm">
                                                    {this.state.isLoading ? "Please Wait..." : "Allocate"}
                                                </button>
                                            </div>
                                        </form>
                                    </Modal>

                                    <div className="col-md-12">
                                        {this.state.showError ? <div >

                                            <Alert color="danger" className="alert--colored" icon>
                                                <p><span className="bold-text">{this.state.statusMessage}</span>
                                                </p>
                                            </Alert>


                                        </div> : null}

                                        {this.state.isShowError ? (
                                            <div>

                                                <Alert color="success" className="alert--colored" icon>
                                                    <p><span className="bold-text">{this.state.statusMessage}</span>
                                                    </p>
                                                </Alert>
                                            </div>
                                        ) : null}<br></br>
                                        <h5>Total Agents: <b>{this.state.total}</b></h5><br />
                                        <ReactDatatable
                                            config={this.config}
                                            records={this.state.data}
                                            columns={this.columns}
                                            dynamic={true}
                                            id="tsc"
                                            loading={this.state.isLoading}
                                            total_record={this.state.total}
                                            onChange={this.tableChangeHandler} />

                                    </div>



                                </CardBody>
                            </Card>
                        </Col >
                    </>
                )
                }
            </div>
        )
    }
}
export default withTranslation('common')(Agents);
